import { Component, OnInit } from '@angular/core';
import {Dsl, Command, StoreInValueModel, TrackExternal, ValueModel} from '@coolon/pectin';
import { DisposableComponent } from '@coolon/angular-ui-powerups';
import { I18n } from '../../i18n';

@Component({
  selector: 'spa-common-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent extends DisposableComponent implements OnInit {

  readonly i18n = I18n.components.pageNotFound;

  constructor() {
    super();
    const {chain} = Dsl.disposeWith(this);
  }

  ngOnInit() {
  }

}
